import React, { Fragment, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from "sweetalert2";
import M from "materialize-css";

import FormularioEditar from "../../../Components/FormularioEditar";
import SideNav from "../../../Components/SideNav";
import Loader from "../../../Components/Loader";

import blogsHelper from "../../../Helpers/Blogs";
import etiquetasBlogHelper from "../../../Helpers/EtiquetasBlogs";
import autoresHelper from "../../../Helpers/AutoresBlogs";

import useStorage from "../../../Hooks/useStorage";

const Blog = () => {
  const licenciaturas = [
    "CINE DIGITAL",
    "MULTIMEDIA",
    "MARKETING DIGITAL",
    "ANIMACIÓN",
  ];

  const [flag, setFlag] = useState(false);
  const [contenido, setContenido] = useState("");
  const [instance, setInstance] = useState({});

  const [blog, setBlog] = useState({});
  const [etiquetas, setEtiquetas] = useState([]);
  const [autores, setAutores] = useState([]);
  const [files, setFiles] = useState([]);
  const [imagenEditada, setImagenEditada] = useState([]);
  const [imagenes, setImagenes] = useState([]);

  // uso de hooks para agregar imagen a google storage
  const [consulta, setConsulta] = useState("");
  let [response] = useStorage(consulta);

  useEffect(() => {
    if (!response) {
      obtenerBlog();
      window.addEventListener("scroll", () => {
        let elemento = document.getElementById("curso_fixme");
        let imagen_estatica = document.getElementById("imagen_estatica");
        let imagen_estatica_bottom =
          imagen_estatica.getBoundingClientRect().bottom;
        if (imagen_estatica_bottom <= 0) {
          if (elemento.className === "curso_fijo") {
            elemento.className = "curso_fixme";
          }
        } else {
          if (elemento.className === "curso_fixme") {
            elemento.className = "curso_fijo";
          }
        }
      });
    } else {
      if (response.action === "eliminarRecursivo") {
        // despues de que se eliminaron las imagenes al eliminar un curso
        eliminarBlog();
      } else if (response.action === "eliminarRecursivoActualizar") {
        // despues de que se eliminaron las imagenes al actualizar curso
        // se van a agregar las imagenes nuevas
        subirArchivo();
      } else if (response.action === "agregarRecursivo") {
        // despues de que se agregaran las imagenes nuevas al editar curso
        // se van a actualizar la imformacion a mongo
        actualizar();
      } else {
        // error
      }
    }
  }, [response]);

  const obtenerBlog = async () => {
    let id = window.location.pathname.split("/")[2];
    let res = await blogsHelper.obtenerUnBlog(id);

    if (res.success) {
      setBlog(res.data);
      setContenido(res.data.contenido);
      obtenerEtiquetas();
    } else {
      Swal.fire(
        "Error!",
        "No se lograron obtener el blog, codigo: " + res.code,
        "error"
      );
    }
  };

  const obtenerEtiquetas = async () => {
    let res = await etiquetasBlogHelper.obtenerEtiquetas();

    if (res.success) {
      setEtiquetas(res.data);
      obtenerAutores();
    } else {
      Swal.fire(
        "Error!",
        "No se pudo obtener las etiquetas, codigo: " + res.code,
        "error"
      );
    }
  };

  const obtenerAutores = async () => {
    let res = await autoresHelper.obtnenreAutores();

    if (res.success) {
      setAutores(res.data);
      setFlag(true);

      setTimeout(() => {
        let elems = document.querySelectorAll("select");
        let instance = M.FormSelect.init(elems);

        setInstance(instance);
      }, 200);
    } else {
      Swal.fire(
        "Error!",
        "No se pudo obtener el blog, codigo: " + res.code,
        "error"
      );
    }
  };

  const actualizarBlog = () => {
    let ventana = document.getElementById("ventana_editable_editar");
    ventana.className = "ventana_editable col s3";
    let vista = document.getElementById("vistas_generales");
    vista.className = "col s9";
    let cerrar = document.getElementById("invisible_cerrar");
    cerrar.className = "invisible_cerrar_activado";

    let ckedittor_contenedor_editar = document.getElementById(
      "ckedittor_contenedor_editar"
    );
    // NOTA: la variable editar la cual la estamos copiando, esta copia es como se encuentra en el ...
    // ... momento que se invoco el reactdom, si se hacen cambios despues de el reactdom se perderan estos cambios
    ReactDOM.render(
      <CKEditor
        editor={ClassicEditor}
        data={blog.contenido}
        onChange={(event, editor) => {
          const data = editor.getData();

          setContenido(data);
        }}
      />,
      ckedittor_contenedor_editar
    );
  };

  function createMarkup(materias) {
    return { __html: materias };
  }

  const funcionBloqueada = () => {
    Swal.fire("Funcion bloqueada!", "No se puede usar esta funcion", "error");
  };

  const leerDato = (e) => {
    setBlog({
      ...blog,
      [e.target.name]: e.target.value,
    });
  };

  const actualizarFoto = (e, index) => {
    let fileTempo = [...files];
    fileTempo[index] = e.target.files[0];

    let copiaImagenEditada = [...imagenEditada];
    let copiaImagenes = [...imagenes];

    if (!imagenes.includes(blog[e.target.name])) {
      copiaImagenes.push(blog[e.target.name]);
      copiaImagenEditada.push(e.target.name);
    }

    setFiles(fileTempo);
    // visualizar la imagen
    let fileReader = new FileReader();
    fileReader.addEventListener("load", function (evt) {
      setBlog({
        ...blog,
        [e.target.name]: fileReader.result,
      });
      setImagenEditada(copiaImagenEditada);
      setImagenes(copiaImagenes);
    });
    fileReader.readAsDataURL(e.target.files[0]);
  };

  const leerOpciones = (e) => {
    e.preventDefault();
    setBlog({
      ...blog,
      [e.target.name]: instance[0].getSelectedValues(),
    });
  };

  const eliminarArchivosRecursivo = (e) => {
    e.preventDefault();

    let urls = [];
    urls.push(blog.imagen);
    urls.push(blog.imagenExterna);

    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea eliminar el campo?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setConsulta({
          consulta: "eliminarRecursivo",
          url: "/blogs-noticias",
          urlsDelete: urls,
        });
      } else if (result.isDenied) {
        Swal.fire("Eliminación cancelada", "El campo quedo intacto", "succes");
      }
    });
  };

  const eliminarBlog = () => {
    blogsHelper.eliminarBlog(blog._id);
  };

  const actualizarArchivo = (e) => {
    e.preventDefault();

    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea modificar el campo?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        if (files.length > 0) {
          eliminarArchivosRecursivoEditar();
        } else {
          actualizar();
        }
      } else if (result.isDenied) {
        Swal.fire(
          "Modificación cancelada",
          "El campo quedo intacto",
          "success"
        );
      }
    });
  };

  const actualizar = () => {
    let body = {
      ...blog,
      contenido,
    };

    if (response.data) {
      imagenEditada.map((imagen, index) => {
        body[imagen] = response.data[index];
      });
    }

    blogsHelper.editarBlog(body, window.location.pathname.split("/")[2]);
  };

  const eliminarArchivosRecursivoEditar = () => {
    let urls = [...imagenes];

    setConsulta({
      consulta: "eliminarRecursivoActualizar",
      url: "/blogs-noticias",
      urlsDelete: urls,
    });
  };

  const subirArchivo = () => {
    setConsulta({
      consulta: "agregarRecursivo",
      name: blog.titulo,
      folder: "blogs/",
      filesJSON: { files },
      url: "/blogs-noticias",
    });
  };

  return (
    <Fragment>
      <SideNav />
      <div className="row">
        <FormularioEditar>
          <p className="titulo_1_admin">Editar blog</p>
          {!flag ? (
            <Loader />
          ) : (
            <form onSubmit={actualizarArchivo}>
              <img alt="imagen Principal" width="100%" src={blog.imagen}></img>
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    name="imagen"
                    onChange={(e) => {
                      actualizarFoto(e, 0);
                    }}
                    type="file"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input
                    name="imagen"
                    class="file-path validate"
                    type="text"
                    placeholder="Imagen Principal"
                  />
                </div>
              </div>

              <img
                alt="imagen secundaria"
                width="100%"
                src={blog.imagenExterna}
              ></img>
              <div class="file-field input-field">
                <div class="btn">
                  <span>File</span>
                  <input
                    name="imagenExterna"
                    onChange={(e) => {
                      actualizarFoto(e, 1);
                    }}
                    type="file"
                  />
                </div>
                <div class="file-path-wrapper">
                  <input
                    name="imagenExterna"
                    class="file-path validate"
                    type="text"
                    placeholder="Imagen Secundaria"
                  />
                </div>
              </div>

              <div className="input-field">
                <input
                  onChange={leerDato}
                  id="titulo"
                  name="titulo"
                  type="text"
                  className="validate"
                  defaultValue={blog.titulo}
                  required
                />
                <label className="active" for="titulo">
                  Titulo
                </label>
              </div>
              <div className="input-field">
                <input
                  onChange={leerDato}
                  id="url"
                  name="url"
                  type="text"
                  className="validate"
                  defaultValue={blog.url}
                  required
                />
                <label className="active" for="url">
                  URL
                </label>
              </div>

              <div class="input-field col s12">
                <select
                  required
                  name="etiquetas"
                  multiple
                  onChange={leerOpciones}
                >
                  {etiquetas.map((etiqueta) =>
                    blog.etiquetas.includes(etiqueta._id) ? (
                      <option selected value={etiqueta._id}>
                        {etiqueta.nombre}
                      </option>
                    ) : (
                      <option value={etiqueta._id}>{etiqueta.nombre}</option>
                    )
                  )}
                </select>
                <label>Etiquetas</label>
              </div>

              <div class="input-field col s12">
                <select required name="autor" onChange={leerDato}>
                  <option value="" disabled selected>
                    Selecciona un autor
                  </option>
                  {autores.map((autor) =>
                    autor._id === blog.autor ? (
                      <option selected value={autor._id}>
                        {autor.nombre}
                      </option>
                    ) : (
                      <option value={autor._id}>{autor.nombre}</option>
                    )
                  )}
                </select>
                <label>Autores</label>
              </div>

              <div class="input-field col s12">
                <select required name="licenciatura" onChange={leerDato}>
                  <option value="" disabled selected>
                    Selecciona una Licenciatura
                  </option>
                  <option
                    selected={blog.licenciatura === 0 ? true : false}
                    value={0}
                  >
                    Cine Digital
                  </option>
                  <option
                    selected={blog.licenciatura === 1 ? true : false}
                    value={1}
                  >
                    Multimedia
                  </option>
                  <option
                    selected={blog.licenciatura === 2 ? true : false}
                    value={2}
                  >
                    Marketing
                  </option>
                  <option
                    selected={blog.licenciatura === 3 ? true : false}
                    value={3}
                  >
                    Animación
                  </option>
                  <option
                    selected={blog.licenciatura === 4 ? true : false}
                    value={4}
                  >
                    Cultura general
                  </option>
                </select>
                <label>Licenciaturas</label>
              </div>

              <div id="ckedittor_contenedor_editar">
                <p>Descripcion</p>
              </div>

              <div className="botonn_1_admin" style={{ marginTop: "10px" }}>
                <button type="submit">Actualizar blog</button>
              </div>
            </form>
          )}
          <div className="botonn_2_admin" style={{ marginTop: "10px" }}>
            <button onClick={eliminarArchivosRecursivo}>Eliminar blog</button>
          </div>
        </FormularioEditar>
      </div>
      <div className="row">
        <div
          id="vistas_generales"
          className="col s12 vistas_generales_cursos"
          style={{ padding: "0", display: "flex", justifyContent: "center" }}
        >
          <div className="container border">
            <div></div>
          </div>
          <div className="container componente_editable_padre">
            {!flag ? (
              <div>
                <Loader />
              </div>
            ) : (
              <Fragment>
                <div className="ancho_imagen_curso">
                  <img
                    src={blog.imagen}
                    alt={blog.titulo}
                    style={{
                      width: "100%",
                    }}
                  />
                </div>

                <div className="container center">
                  <p
                    className="encabezadosMonserrat"
                    style={{ fontWeight: "bolder" }}
                  >
                    {blog.titulo}
                  </p>
                </div>

                <div className="row" style={{ marginTop: "50px" }}>
                  <div className="col s12 m12 l8">
                    <div
                      className="informacion_curso"
                      dangerouslySetInnerHTML={createMarkup(contenido)}
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <button
                        onClick={() => {
                          funcionBloqueada();
                        }}
                        className="etiqueta-curso"
                      >
                        <p>{licenciaturas[blog.licenciatura]}</p>
                      </button>
                      {etiquetas.map(
                        (etiqueta) =>
                          blog.etiquetas.includes(etiqueta._id) && (
                            <button
                              onClick={() => {
                                funcionBloqueada();
                              }}
                              className="etiqueta-curso-2"
                            >
                              <p>{etiqueta.nombre}</p>
                            </button>
                          )
                      )}
                    </div>
                  </div>
                  <div
                    style={{ paddingLeft: "50px" }}
                    className="col s12 m12 l4"
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        margin: "40px 0 60px 0",
                      }}
                    >
                      <div className="busqueda_cursos">
                        <input
                          placeholder="Buscar por titulo"
                          id="nombre_materia"
                          name="nombre_materia"
                          type="text"
                          className="validate formulario"
                        />
                        <label for="nombre_materia"></label>
                      </div>
                    </div>
                    <p
                      className="titulo_4_nv"
                      style={{ marginBottom: "0px", color: "#00496C" }}
                    >
                      Buscar por temas
                    </p>
                    <div className="row">
                      <div className="col s6 boton-licenciatura-blog-2">
                        <button>CINE DIGITAL</button>
                      </div>
                      <div className="col s6 boton-licenciatura-blog-2">
                        <button>MULTIMEDIA</button>
                      </div>
                      <div className="col s6 boton-licenciatura-blog-2">
                        <button>MARKETING DIGITAL</button>
                      </div>
                      <div className="col s6 boton-licenciatura-blog-2">
                        <button>ANIMACIÓN</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </div>
          <div
            onClick={() => {
              actualizarBlog();
            }}
            className="container efecto_blur"
          ></div>
        </div>
      </div>
    </Fragment>
  );
};

export default Blog;
